var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_59)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_59",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 40V0L0 0V40H40Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7035 5.18701C33.0203 3.02891 37.5782 7.67987 35.3236 11.9478H35.3226L33.9564 14.5142L33.9515 14.5229L33.9476 14.5308C33.8418 14.7425 33.6746 14.8941 33.4838 14.9722L33.472 14.9771L33.4603 14.9829L12.3822 24.4644H12.3812C11.8702 24.6903 11.2811 24.4799 11.0336 24.0044L11.0316 24.0005L4.68201 11.9341L4.68103 11.9321C2.42704 7.68422 6.97826 3.02683 11.2992 5.18701L17.099 8.0874L17.1019 8.08838C18.9282 8.99211 21.0579 8.99211 22.8842 8.08838L22.8861 8.0874L28.7025 5.18799L28.7035 5.18701Z",
    stroke: "#265185",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2764 21.5889C29.1179 21.3629 29.8861 22.2702 29.4542 23.0801L29.4522 23.083L24.3858 32.7002C22.5171 36.2494 17.449 36.2493 15.5801 32.7002L13.8008 29.3096C13.5281 28.7739 13.7488 28.1242 14.3077 27.8672L28.1075 21.6504H28.1085L28.2764 21.5889Z",
    stroke: "#187550",
    strokeWidth: 1.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "matrix(0 1 -1 0 40 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.f13762ca1374f129d36431ebde87fac6.svg";
export { ForwardRef as ReactComponent };